// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyDm7jrAqDdKT-eZFRNZZxBANfAm8M9g79E',
  authDomain: 'bidyourstay-92d2d.firebaseapp.com',
  projectId: 'bidyourstay-92d2d',
  storageBucket: 'bidyourstay-92d2d.firebasestorage.app',
  messagingSenderId: '48767189738',
  appId: '1:48767189738:web:d09fa27009d1a1d6290d93',
  measurementId: 'G-YVV9RWQM5R',
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
